import { render, staticRenderFns } from "./LiveControls.vue?vue&type=template&id=f27de6f4&scoped=true&"
import script from "./LiveControls.vue?vue&type=script&lang=js&"
export * from "./LiveControls.vue?vue&type=script&lang=js&"
import style0 from "./LiveControls.vue?vue&type=style&index=0&id=f27de6f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27de6f4",
  null
  
)

export default component.exports